
import { RoleDetail } from "app/main/signing-pages/signing-page/signing-page.dto";

export interface Options {
    role_id?: number;
    roleDetail?: RoleDetail,
    hide_settings?:boolean,
    isEform?: boolean,
    area?: AreaType
}

export enum AreaType {
    Editor = 'editor',
    Signing = 'signing'
}

export enum ContentBoxAction {
  CreateParent = 'CreateParent',
  CloneFullContentBox = 'CloneFullContentBox',
  None = 'None'
}